export const CreatePullSheetStatus = {
  PENDING: 'pending',
  IMPORTING: 'importing',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const

export type CreatePullSheetStatusType = (typeof CreatePullSheetStatus)[keyof typeof CreatePullSheetStatus]

export const createPullSheetStatusMap: Record<CreatePullSheetStatusType, string> = {
  [CreatePullSheetStatus.PENDING]: '未建立',
  [CreatePullSheetStatus.IMPORTING]: '建立中',
  [CreatePullSheetStatus.COMPLETED]: '已建立',
  [CreatePullSheetStatus.FAILED]: '建立失敗',
}
